import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileDown, Presentation, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const iso = (d) => d.toISOString().slice(0, 10);
const todayUtc = () => iso(new Date());
const daysAgoUtc = (n) => iso(new Date(Date.now() - n * 86400000));

const readError = async (e) => {
  try {
    const detail = JSON.parse(await e.response.data.text()).detail;
    return typeof detail === 'string' ? detail : 'Export failed. Please check the dates.';
  } catch { return 'Export failed'; }
};

export const PerformanceReportExport = () => {
  const [start, setStart] = useState(daysAgoUtc(29));
  const [end, setEnd] = useState(todayUtc());
  const [busy, setBusy] = useState(null);

  const download = async (format) => {
    if (!start || !end) { toast.error('Choose both a start date and an end date.'); return; }
    setBusy(format);
    try {
      const res = await axios.get(`${API}/admin/analytics/report/export`, {
        params: { format, start_date: start, end_date: end }, withCredentials: true, responseType: 'blob',
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `steelpeak-performance-${start}-to-${end}.${format}`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${format.toUpperCase()} report downloaded`);
    } catch (e) {
      toast.error(await readError(e));
    } finally { setBusy(null); }
  };

  const btn = 'inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium disabled:opacity-50 transition-colors';
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="performance-report-export">
      <span className="w-full text-[11px] font-semibold uppercase tracking-wider text-[#475569]">Export report range</span>
      <label className="text-xs text-[#475569]">From
        <input type="date" value={start} max={end} onChange={(e) => setStart(e.target.value)}
          className="block mt-0.5 rounded-md border border-[#e2e8f0] px-2 py-1 text-xs" data-testid="report-start-date" />
      </label>
      <label className="text-xs text-[#475569]">To
        <input type="date" value={end} min={start} max={todayUtc()} onChange={(e) => setEnd(e.target.value)}
          className="block mt-0.5 rounded-md border border-[#e2e8f0] px-2 py-1 text-xs" data-testid="report-end-date" />
      </label>
      <button onClick={() => download('pptx')} disabled={!!busy} data-testid="report-export-pptx-button"
        className={`${btn} bg-[#0f2444] text-white hover:bg-[#1e3a63]`}>
        {busy === 'pptx' ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Presentation className="w-3.5 h-3.5" />} Export PPT
      </button>
      <button onClick={() => download('pdf')} disabled={!!busy} data-testid="report-export-pdf-button"
        className={`${btn} border border-[#e2e8f0] bg-white text-[#0f172a] hover:bg-[#f8fafc]`}>
        {busy === 'pdf' ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileDown className="w-3.5 h-3.5" />} Export PDF
      </button>
    </div>
  );
};
